module.exports = __webpack_public_path__ + "img/1548617571.61b4ed76.jpg";